/* eslint eqeqeq: "off" */
import React, { useEffect, useState } from "react";
import { Col, FloatButton, Image, Modal, Row } from "antd";
import {
  CommentOutlined,
  CloseOutlined,
} from "@ant-design/icons";
import "./index.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import useMedia from "use-media-antd-query";
import PropTypes from "prop-types";
import BannerContent from "./bannerContent";
import { useHistory, withRouter } from "react-router";
import NewLaunches from "./newLaunches";
import Wonders from "./scenic-wonders";
import HolidaPackages from "./holiday-packages";
import ReadingCorners from "./reading-corner";
import Benefits from "./benefits";
import TravellerReview from "./traveller-review";
import { IoShieldCheckmarkSharp } from "react-icons/io5";
import { useDispatch, useSelector } from "react-redux";
import { loadDynamicImagesList } from "../../store/dashboard/actions";
import { SampleNextArrow, SamplePrevArrow } from "../../helpers/utils";
import { MetaTags } from "react-meta-tags";

const Landing = () => {
  const media = useMedia();
  const history = useHistory();
  const dispatch = useDispatch();
  const [chatModal, setChatModal] = useState(false);

  //store integrations

  useEffect(() => {
    dispatch(loadDynamicImagesList());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { dynamic_images_list = [] } = useSelector((state) => state.Dashboard);

  //image api list functionality

  const dynamicImagesList =
    dynamic_images_list !== undefined &&
    dynamic_images_list.length !== 0 &&
    dynamic_images_list.queryResult &&
    dynamic_images_list.queryResult.length > 0
      ? dynamic_images_list.queryResult
          .filter((data) => data.sectionName === "Home Screen Top Banner")
          .flatMap((data) =>
            data.images.map((image) => {
              return {
                sectionName: data !== undefined ? data.sectionName : "",
                sectionId: data !== undefined ? data.sectionId : "",
                order: image.order,
                redirectLink: image.redirectLink,
                _id: image._id,
                size: data.size,
                imageUrl: image.imageUrl,
              };
            })
          )
      : [];

  const dynamicImageSlides =
    dynamic_images_list !== undefined && dynamicImagesList.length > 0
      ? dynamicImagesList.filter((data) => data.sectionName !== undefined)
      : [];

  const slides =
    dynamicImagesList &&
    dynamicImagesList.length > 0 &&
    dynamicImageSlides.length > 0
      ? dynamicImageSlides.map((data) => {
          // const sizes =
          const [width, height] =
            data.size && data.size.split("x").map((val) => val.trim());

          const imgHeight = parseFloat(height);
          const imgWidth = parseFloat(width);
          const url = data.redirectLink && data.redirectLink;
          // const url =
          //   data.redirectLink &&
          //   data.redirectLink.replace(
          //     "https://pmt.mequalsvps.in/" || "localhost:3001",
          //     "packages/"
          //   );
          // const url = data.redirectLink && data.redirectLink;
          return {
            sectionName: data !== undefined ? data.sectionName : "",
            sectionId: data !== undefined ? data.sectionId : "",
            order: data.order,
            redirectLink: url,
            id: data._id,
            imgHeight: imgHeight,
            imgWidth: imgWidth,
            size: data.size,
            imageUrl: data.imageUrl,
          };
        })
      : [];

  const settings = {
    // className: "center",
    centerMode: true,
    // dots: true, // Show navigation dots
    infinite: slides && slides.length > 1,
    centerPadding: "5px",
    slidesToShow: 1,
    fade: true,
    autoplay: true,
    autoplaySpeed: 2600,
    nextArrow: <SampleNextArrow marginRight="50px" />,
    prevArrow: <SamplePrevArrow marginLeft="50px" />,
    cssEase: "linear",
  };

  return (
    <React.Fragment>
      <div className="">
        <MetaTags>
          <title>Home | Plan Mi Trip</title>
        </MetaTags>
      </div>
      <Col md={24} sm={24} lg={24} xl={24} xxl={24} xs={24}>
        <div
          style={{
            width: "101%",
            // overflowX: "hidden",
            marginLeft: "-6px",
            marginTop: "-20px",
            // overflowY: "hidden",
          }}
        >
          {slides && slides.length > 0 ? (
            <Slider {...settings} centerMode className="h-[100%] w-[100%]">
              {slides.length > 0 &&
                slides.map((slide) => (
                  <div
                    key={slide.id}
                    onClick={() => {
                      if (slide.redirectLink.startsWith("http")) {
                        window.location.href = slide.redirectLink;
                        // history.push(slide.redirectLink);
                      } else {
                        // For internal routes (within localhost)
                        history.push(slide.redirectLink); // React Router
                      }
                    }}
                    className="cursor-pointer mb-[-30px]"
                  >
                    <Image
                      preview={false}
                      alt=""
                      src={slide.imageUrl}
                      width={"100%"}
                      height={slide.imgHeight}
                    />
                  </div>
                ))}
            </Slider>
          ) : (
            // ""
            <Slider {...settings} centerMode className="h-[100%] w-[100%]">
              <Image
                preview={false}
                // alt="no-img"
                src={""}
                width={"100%"}
                height={420}
                className="text-center"
              />
            </Slider>
          )}
        </div>
        {/* <Row
          className={
            media == "sm"
              ? "pr-[30px] pl-[30px]"
              : media == "xs"
              ? "pl-[30px]"
              : "pr-[0.5%] pl-[0.5%]"
          }
        >
          <Col  md={24}
            sm={24}
            lg={24}
            xl={24}
            xxl={24}
            xs={24}>
            <SubBanner />
          </Col>
        </Row> */}
        <Row
          className={
            media == "sm"
              ? "pr-[30px] pl-[30px]"
              : media == "xs"
              ? ""
              : media == "md"
              ? "pr-[0.5%] pl-[0.5%]"
              : media == "lg"
              ? "pr-[2%] pl-[2%]"
              : media == "xxl"
              ? "pr-[6.5%] pl-[7.5%]"
              : "pr-[0.5%] pl-[0.5%]"
          }
        >
          <Col md={24} sm={24} lg={24} xl={24} xxl={24} xs={24}>
            <BannerContent />
          </Col>
        </Row>
        <Row>
          <Col
            md={24}
            sm={24}
            lg={24}
            xl={24}
            xxl={24}
            xs={24}
            className={
              media == "sm" || media == "xs"
                ? "pr-[30px] pl-[30px]"
                : media == "md"
                ? "pr-[0.5%] pl-[0.5%]"
                : media == "lg"
                ? "pr-[2%] pl-[2%]"
                : media == "xxl"
                ? "pr-[6.5%] pl-[7.5%]"
                : "pr-[0.5%] pl-[0.5%]"
            }
          >
            <NewLaunches />
          </Col>
        </Row>
        <Row
          className={
            media == "sm"
              ? "mt-3 pr-[30px] pl-[30px]"
              : media == "xs"
              ? "mt-3 pr-[10px] pl-[10px]"
              : media == "md"
              ? "pr-[0.5%] pl-[0.5%]"
              : media == "lg"
              ? "pr-[2%] pl-[2%]"
              : media == "xxl"
              ? "pr-[6.5%] pl-[7.5%]"
              : "pr-[0.5%] pl-[0.5%]"
          }
        >
          <Col md={24} sm={24} lg={24} xl={24} xxl={24} xs={24}>
            <Wonders />
          </Col>
        </Row>
        <Row
          className={
            media == "sm"
              ? "pr-[30px] pl-[30px]"
              : media == "xs"
              ? ""
              : media == "md"
              ? "pr-[0.5%] pl-[0.5%]"
              : media == "lg"
              ? "pr-[2%] pl-[2%]"
              : media == "xxl"
              ? "pr-[6.5%] pl-[7.5%]"
              : "pr-[0.5%] pl-[0.5%]"
          }
        >
          <Col md={24} sm={24} lg={24} xl={24} xxl={24} xs={24}>
            <HolidaPackages />
          </Col>
        </Row>
        {/* <Row>
          <Col  md={24}
            sm={24}
            lg={24}
            xl={24}
            xxl={24}
            xs={24}>
            <Specials />
          </Col>
        </Row> */}

        <Row
          className={
            media == "sm"
              ? "pr-[30px] pl-[30px]"
              : media == "xs"
              ? ""
              : media == "md"
              ? "pr-[0.5%] pl-[0.5%]"
              : media == "lg"
              ? "pr-[2%] pl-[2%]"
              : media == "xxl"
              ? "pr-[6.5%] pl-[7.5%]"
              : "pr-[0.5%] pl-[0.5%]"
          }
        >
          <Col md={24} sm={24} lg={24} xl={24} xxl={24} xs={24}>
            <Benefits />
          </Col>
        </Row>
        <Row
          className={
            media == "sm"
              ? "pr-[30px] pl-[30px]"
              : media == "xs"
              ? ""
              : media == "md"
              ? "pr-[0.5%] pl-[0.5%]"
              : media == "lg"
              ? "pr-[2%] pl-[2%]"
              : media == "xxl"
              ? "pr-[6.5%] pl-[7.5%]"
              : "pr-[0.5%] pl-[0.5%]"
          }
        >
          <Col md={24} sm={24} lg={24} xl={24} xxl={24} xs={24}>
            <TravellerReview />
          </Col>
        </Row>
        <Row
          className={
            media == "sm"
              ? "pr-[30px] pl-[30px]"
              : media == "xs"
              ? ""
              : media == "md"
              ? "pr-[0.5%] pl-[0.5%]"
              : media == "lg"
              ? "pr-[2%] pl-[2%]"
              : media == "xxl"
              ? "pr-[6.5%] pl-[7.5%]"
              : "pr-[0.5%] pl-[0.5%]"
          }
        >
          <Col md={24} sm={24} lg={24} xl={24} xxl={24} xs={24}>
            <ReadingCorners />
          </Col>
        </Row>
        {/* <Modal
          open={chatModal}
          closeIcon={true}
          title="Chat"
          destroyOnClose
          onCancel={closeChat}
        >
          Content
        </Modal> */}
        <Modal
          open={chatModal}
          title=""
          maskClosable={false}
          onClose={() => setChatModal(false)}
          // onCancel={() => setChatModal(false)}
          // onCancel={false}
          closable
          footer={null}
          closeIcon={
            <CloseOutlined
              onClick={() => setChatModal(false)}
              className="text-[#ffffff]"
            />
          }
          width={600}
        >
          {/* <Divider
            style={{
              borderWidth: "0.2px",
              width: "108.5%",
              marginLeft: "-24px",
            }}
          /> */}
          <Col md={24} sm={24} lg={24} xl={24} xxl={24} xs={24}>
            <div className="w-[107%] ml-[-20px] mt-[-16px] h-[200px] global-modal-img rounded-md">
              <Row>
                <Col
                  style={{
                    fontFamily: "Poppins",
                  }}
                  md={12}
                  sm={12}
                  lg={12}
                  xl={12}
                  xxl={12}
                  className="p-3"
                >
                  <h2 className="text-[#ffffff]">
                    Don't miss out on our exclusive deals & insider only offers!
                  </h2>
                  <div className="text-[#ffffff] mt-2">
                    <div className="flex">
                      <p>
                        <IoShieldCheckmarkSharp className="mt-1 text-[red] mr-2" />
                      </p>
                      5 years of Experience in India
                    </div>
                    <div className="flex">
                      <p>
                        <IoShieldCheckmarkSharp className="mt-1 text-[red] mr-2" />
                      </p>
                      Packages across 50 + Countries
                    </div>
                    <div className="flex">
                      <p>
                        <IoShieldCheckmarkSharp className="mt-1 text-[red] mr-2" />
                      </p>
                      Best Travel Partner of India
                    </div>
                  </div>
                </Col>
                <Col md={12} sm={12} lg={12} xl={12} xxl={12}></Col>
              </Row>
            </div>
          </Col>

          {/* <Collapse
            items={paymentFaqList}
            expandIcon={<DownCircleOutlined />}
            expandIconPosition="right"
            className="font-semibold"
            bordered
            style={{
              fontFamily: "Poppins",
            }}
          /> */}
        </Modal>
        <FloatButton
          className="w-[50px] h-[50px]"
          type="primary"
          style={{
            margin: "-7px",
            background: "#eb3a3e",
          }}
          onClick={() => setChatModal(!chatModal)}
          icon={<CommentOutlined />}
        />
      </Col>
    </React.Fragment>
  );
};

Landing.propTypes = {
  location: PropTypes.any,
};

export default withRouter(Landing);
